<template>
  <main-layout>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" color="amber" />
    </v-overlay>
    <base-header>
      <template #icon> mdi-file</template>
      <template #name> View Purchase Order</template>
      <template #breadcrumbs>
        <v-breadcrumbs :items="breadcrumbs" class="pa-0">
          <template #divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </template>
      <template #button>
        <v-btn color="secondary" class="float-end mb-2" small @click="backForm()">Back
          <v-icon right>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
    </base-header>
    <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet">
    <v-card elevation="2" rounded class="mx-2">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default invoice" id="invoice">
            <div class="panel-body">
              <v-row class="mx-2">
                <v-col sm="12" md="6" lg="6">
                  <h3 class="marginright">{{ PurchaseOrder.no_po }}</h3>
                  <span class="marginright">{{ PurchaseOrder.purchase_date }}</span>
                </v-col>

                <v-col sm="12" md="6" lg="6" class="top-right">
                  <h3 class="marginright">{{ PurchaseOrder.status }}</h3>
                </v-col>
              </v-row>
              <v-divider class="mx-4"></v-divider>
              <br>
              <v-row class="mx-2">
                <v-col sm="12" md="4" lg="4" class="from">
                  <h3 class="lead marginbottom">From : {{ PurchaseOrder.branch_name }}</h3>
                  <p>{{ PurchaseOrder.branch_phone }}</p>
                  <p>{{ PurchaseOrder.branch_email }}</p>
                  <p>{{ PurchaseOrder.branch_address }}</p>
                </v-col>
                <v-col sm="12" md="4" lg="4" class="from">
                  <h3 class="lead marginbottom">To : {{ PurchaseOrder.supplier_name }}</h3>
                  <p>{{ PurchaseOrder.supplier_phone }}</p>
                  <p>{{ PurchaseOrder.supplier_email }}</p>
                  <p>{{ PurchaseOrder.supplier_address }}</p>
                </v-col>
                <v-col sm="12" md="4" lg="4" class="from">
                  <h3 class="lead marginbottom">Purchase Shipping</h3>
                  <p>{{ PurchaseOrder.customer_name }}</p>
                  <p>{{ PurchaseOrder.customer_phone }}</p>
                  <p>{{ PurchaseOrder.customer_email }}</p>
                  <p>{{ PurchaseOrder.customer_address }}</p>
                </v-col>
              </v-row>
              <v-divider class="mx-4"></v-divider>
              <v-row class="mx-2 table-row">
                <v-col lg="12">
                  <v-simple-table class="mx-2 my-3" width="100%" fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="1px">No</th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="20px">Product Name
                          </th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="20px">Material Name
                          </th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="25px">Description</th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="15px">Unit</th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="10px">Price Buy</th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="10px">Qty</th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="10px">Qty Material
                          </th>
                          <th class="text-left white--text" style="background-color:#3BA0FF" width="15px">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in PurchaseOrder.details" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            {{ row?.item?.name ?? "" }}
                          </td>
                          <td>
                            <ul>
                              <li v-for="(ingredient, index) in row?.item?.item_ingredients" :key="index">
                                {{ ingredient?.ingredient?.name }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            {{ row?.item?.description ?? "" }}
                          </td>
                          <td>{{ row?.item?.unit?.name ?? "" }}</td>
                          <td>
                            {{
                              row.price | currency("", 0, { symbolOnLeft: false })
                            }}
                          </td>
                          <td> {{
                            row.qty | currency("", 0, { symbolOnLeft: false })
                          }}</td>
                          <td>
                            <ul>
                              <li v-for="(ingredient, index) in row?.item?.item_ingredients" :key="index">
                                {{ ingredient?.qty_usage }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            {{
                              (row.price * row.qty) | currency("", 0, {
                                symbolOnLeft:
                                  false
                              })
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-divider class="mx-4"></v-divider>
              <br>
              <v-row class="mx-2">
                <v-col sm="12" md="6" lg="6" class="margintop">
                  <p class="lead marginbottom">THANK YOU!</p>
                </v-col>
                <v-col sm="12" md="6" lg="6" class="text-right pull-right invoice-total">
                  <p>Subtotal : {{ PurchaseOrder.sub_total | currency("", 0, {
                    symbolOnLeft:
                      false
                  }) }}</p>
                  <p>Discount ({{ PurchaseOrder.discount_percent, }}%) : {{ PurchaseOrder.discount_amount | currency("",
                    0, {
                    symbolOnLeft:
                      false
                  }) }} </p>
                  <p>VAT (11%) : {{ PurchaseOrder.vat | currency("", 0, {
                    symbolOnLeft:
                      false
                  }) }} </p>
                  <p>Grand Total : {{ PurchaseOrder.grand_total | currency("", 0, {
                    symbolOnLeft:
                      false
                  }) }} </p>
                </v-col>
              </v-row>

            </div>
          </div>
        </div>
      </div>
    </v-card>
    <link />

  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import BaseHeader from '@/components/base/BaseHeader.vue';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: "PurchaseOrderView",

  data() {
    return {
      loading: false,
      btnLoading: false,
      breadcrumbs: [
        { text: "Transaction", disabled: false },
        { text: "Purchase Order", disabled: false },
        { text: "View", disabled: true },

      ],
    };

  },

  created() {
    this.init();
  },

  methods: {
    ...mapMutations("purchase_order", ["CLEAR_STATE", "SET_PURCHASE_ORDER"]),

    init() {
      this.loading = true;
      this.$axios
        .get("/transaction/purchases/" + this.$route.params.id, {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_PURCHASE_ORDER(data.purchase_orders);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    clear() {
      this.CLEAR_STATE();
    },

    backForm() {
      this.CLEAR_STATE();
      this.$router.push("/purchase-order");
    },
  },

  computed: {
    ...mapGetters("purchase_order", ["PurchaseOrder"]),
  },

  components: {
    MainLayout,
    BaseHeader,
  },
}
</script>

<style>
body {
  margin-top: 20px;
  background: #eee;
}

/*Invoice*/
.invoice .top-left {
  font-size: 15px;
  color: #3ba0ff;
}

.invoice .top-right {
  text-align: right;
  padding-right: 20px;
  color: #3ba0ff;
}

.invoice .table-row {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 25px;
}

.invoice .payment-info {
  font-weight: 500;
}

.invoice .table-row .table>thead {
  border-top: 1px solid #ddd;
}

.invoice .table-row .table>thead>tr>th {
  border-bottom: none;
}

.invoice .table>tbody>tr>td {
  padding: 8px 20px;
}

.invoice .invoice-total {
  margin-right: -10px;
  font-size: 16px;
}

.invoice .last-row {
  border-bottom: 1px solid #ddd;
}

.invoice-ribbon {
  width: 100px;
  height: 180px;
  top: auto;
  overflow: hidden;
  position: absolute;
  top: 10px;
  right: 20px;
}

.ribbon-inner {
  text-align: center;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  position: relative;
  padding: 9px 0;
  left: -5px;
  top: 18px;
  width: 120px;
  background-color: #66c591;
  font-size: 15px;
  color: #fff;
}

.ribbon-inner:before,
.ribbon-inner:after {
  content: "";
  position: absolute;
}

.ribbon-inner:before {
  left: 0;
}

.ribbon-inner:after {
  right: 0;
}

@media(max-width:575px) {

  .invoice .top-left,
  .invoice .top-right,
  .invoice .payment-details {
    text-align: center;
  }

  .invoice .from,
  .invoice .to,
  .invoice .payment-details {
    float: none;
    width: 100%;
    text-align: center;
    margin-bottom: 25px;
  }

  .invoice p.lead,
  .invoice .from p.lead,
  .invoice .to p.lead,
  .invoice .payment-details p.lead {
    font-size: 22px;
  }

  .invoice .btn {
    margin-top: 10px;
  }
}

@media print {
  .invoice {
    width: 900px;
    height: 800px;
  }
}
</style>